import { useEffect, useRef, type FC, type PropsWithChildren } from 'react'

import { useSlideGesture } from 'hooks/useSlideGesture'
import { useClosePanel, useIsPanelOpen } from 'stores/usePanelsStateStore'
import { useIsXlOrAbove } from 'stores/useScreenSizeStore'
import { cn } from 'utils/cn'

import { ConversationExpirationOnboarding } from './ConversationExpirationOnboarding'
import { ScrollToTopButton } from './ScrollToTopButton'

export const ConversationMenuPanel: FC<PropsWithChildren> = ({
  children,
}) => {
  const panelRef = useRef<HTMLElement>(null)

  const isXlOrAbove = useIsXlOrAbove()

  const isConversationMenuPanelOpen = useIsPanelOpen('conversations_menu')
  const closePanel = useClosePanel()

  useSlideGesture({
    horizontal: true,
    onSlideLeft: () => {
      if (!isConversationMenuPanelOpen) return
      closePanel('conversations_menu')
    },
    ref: panelRef,
  })

  useEffect(() => {
    if (!isXlOrAbove) closePanel('conversations_menu')
  }, [closePanel, isXlOrAbove])

  return (
    <>
      <aside
        ref={panelRef}
        tabIndex={-1}
        className={cn(
          'fixed flex flex-col bg-light top-13 lg:top-15 left-0 h-[calc(100vh-52px)] lg:h-[calc(100vh-60px)] transition-all lg:pt-5 border-r border-r-light overflow-y-auto print:hidden',
          {
            'p-2 lg:w-[80px] z-[2] -translate-x-full lg:translate-x-0': !isConversationMenuPanelOpen,
            'p-5 w-[300px] z-[11] translate-x-0': isConversationMenuPanelOpen,
          },
        )}
      >
        {children}
        {isConversationMenuPanelOpen && <ScrollToTopButton panelRef={panelRef} />}
      </aside>
      {isConversationMenuPanelOpen && <ConversationExpirationOnboarding />}
    </>
  )
}
